import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "detail", "fileInput", "fileWrapper"]

  connect() {
    this.showDetail()
  }

  change() {
    this.showDetail()
  }

  showDetail() {
    const option = this.#selectedOption()
    const raw = option?.dataset?.modelInfo

    if (!raw) {
      // Nothing selected yet
      this.#hideDetail()
      this.#setFileEnabled(false)
      this.#setFileVisible(false)
      return
    }

    const { name, format, thresholds, fine_tuning_supported, fine_tuning_note } = JSON.parse(raw)

    if (fine_tuning_supported === false) {
      // Model doesn't support fine-tuning
      this.#setFileEnabled(false)
      this.#setFileVisible(false)
      this.detailTarget.hidden = false
      this.detailTarget.className = "alert alert-warning border py-2 px-3 mb-2"
      this.detailTarget.innerHTML = `
        <div class="d-flex align-items-start gap-2">
          <i class="bi bi-slash-circle text-warning mt-1 flex-shrink-0"></i>
          <div class="small">
            <strong>Fine-tuning not supported</strong> for ${name}.
            ${fine_tuning_note ? `<span class="text-muted">${fine_tuning_note}</span>` : ""}
          </div>
        </div>
      `
      return
    }

    // Fine-tuning supported — show format hints and enable file input
    this.#setFileEnabled(true)
    this.#setFileVisible(true)

    const columns = format.columns
      .map(c => `<code class="bg-primary bg-opacity-10 px-1 rounded">${c}</code>`)
      .join(" ")

    this.detailTarget.hidden = false
    this.detailTarget.className = "alert alert-light border py-2 px-3 mb-2"
    this.detailTarget.innerHTML = `
      <div class="small fw-semibold mb-1">
        <i class="bi bi-file-earmark-spreadsheet me-1"></i>${name}
      </div>
      <div class="small mb-1">Columns: ${columns} &mdash; <span class="text-muted">${format.description}</span></div>
      <div class="d-flex gap-3" style="font-size: 0.75rem;">
        <span><span class="text-danger fw-bold">${thresholds.minimum}</span> <span class="text-muted">min</span></span>
        <span><span class="text-warning fw-bold">${thresholds.recommended}+</span> <span class="text-muted">recommended</span></span>
        <span><span class="text-success fw-bold">${thresholds.ideal}+</span> <span class="text-muted">ideal</span></span>
      </div>
    `
  }

  #hideDetail() {
    this.detailTarget.innerHTML = ""
    this.detailTarget.hidden = true
  }

  #setFileEnabled(enabled) {
    if (this.hasFileInputTarget) {
      this.fileInputTarget.disabled = !enabled
    }
  }

  #setFileVisible(visible) {
    if (this.hasFileWrapperTarget) {
      this.fileWrapperTarget.hidden = !visible
    }
  }

  #selectedOption() {
    if (this.hasSelectTarget) {
      return this.selectTarget.selectedOptions[0]
    }
    return this.element.querySelector("input[type='radio']:checked")
  }
}
